module.exports = __webpack_public_path__ + "media/images/icons/outlined/radius-bottomleft-d3d031dc3c6dd3edb94b717eff1f8d08.svg";